import {useAppSelector} from "../../../../../../../redux/hooks";
import {
  isMySongsPageSelectedSongDetailsLoadedWithLessons
} from "../../../../../modules/my-songs-page-store/mySongsPage.selectors";

export interface IWhenSongDetailsLoadedWithLessonsLogic {
  isConditionPassed: boolean;
}

export const useWhenSongDetailsLoadedWithLessonsLogic = (): IWhenSongDetailsLoadedWithLessonsLogic => {
  const isConditionPassed = useAppSelector(isMySongsPageSelectedSongDetailsLoadedWithLessons);
  return {
    isConditionPassed,
  };
}
